// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const xerneas: PokeData = {
  "id": 716,
  "name": "xerneas",
  "height": 30,
  "weight": 2150,
  "base_experience": 306,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "aurora-beam",
    "light-screen",
    "outrage",
    "megahorn",
    "psych-up",
    "nature-power",
    "ingrain",
    "aromatherapy",
    "gravity",
    "close-combat",
    "night-slash",
    "giga-impact",
    "heal-pulse",
    "horn-leech",
    "misty-terrain",
    "moonblast",
    "geomancy"
  ],
  "moves": [
    "tackle",
    "outrage",
    "aromatherapy",
    "close-combat",
    "night-slash",
    "misty-terrain",
    "moonblast",
    "mist-terrain",
    "guardian-bond",
    "play-rough",
    "starfall",
    "dazzling-gleam",
    "spirit-break"
  ],
  "evolution_chain": {
    "id": 368,
    "item": null,
    "species": [
      {
        "name": "xerneas",
        "order": 716,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 116,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
